<div class="grid-1col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-text-input [form]="form" id="code" [prefix]="prefix"></app-text-input>
    <app-text-input [form]="form" id="description" [prefix]="prefix"></app-text-input>
    <app-date-input
        [form]="form"
        id="dateFrom"
        [prefix]="prefix"
        [timeType]="'startOfDay'"
    ></app-date-input>
    <app-date-input
        [form]="form"
        id="dateTo"
        [prefix]="prefix"
        [timeType]="'endOfDay'"
    ></app-date-input>
</div>
